import { useFetchProductTypesQuery } from "@src/generated";

export function useProductTypes() {
  const { data, loading, fetchMore } = useFetchProductTypesQuery();
  return data;
}
